module.exports = "<p>\n  workshops works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/workshops/workshops.component.html
// module id = ./src/app/routes/workshops/workshops.component.html
// module chunks = main